import { render, staticRenderFns } from "./IsBeAuth.vue?vue&type=template&id=71b49e90&"
import script from "./IsBeAuth.vue?vue&type=script&lang=ts&"
export * from "./IsBeAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports